import { action, makeObservable, observable, runInAction } from 'mobx';
import { buildWhereFilter, destroy, get, patch, post } from 'stores/_services/dataService';
import { getListConditions } from 'stores/_services/filterService';

export interface IDevice {
    id: string;
    name?: string;
    active?: boolean;
    organizationId?: string;
    organizationName?: string;
    locationId?: string;
    locationName?: string;
    deviceGroupId?: string;
    deviceGroupName?: string;
    hostname?: string;
    alertCount?: number;
    status?: string;
    version?: string;
    ip?: string;
    os?: string;
    type?: string;
    heartbeat?: string;
    isolated?: boolean;
    data?: {
        vsaId?: string;
        rmmUid?: string;
    };
    organization?: {
        id?: string;
        name?: string;
        data?: any;
    };
    location?: {
        id?: string;
        name?: string;
        data?: any;
    };
    markedForUninstall?: boolean;
}

export default class DeviceStore {
    device: IDevice = {
        id: '',
        name: '',
        organizationId: '',
        locationId: '',
        deviceGroupId: ''
    };

    constructor(device: IDevice) {
        makeObservable(this, {
            device: observable,
            update: action,
            renameDevice: action,
            deleteDevice: action
        });

        this.update(device);
    }

    update(device: IDevice): void {
        this.device = {
            ...this.device,
            ...device
        };
    }

    async existsDeviceName(name: string): Promise<boolean> {
        const options = {
            filter: {
                where: { name: name, locationId: this.device.locationId }
            }
        };
        const { data } = await get('agents', options);
        return !!data.length;
    }

    async existsDeviceNameInLocation(name: string, locationId: string): Promise<boolean> {
        const options = {
            filter: {
                where: { name: name, locationId: locationId }
            }
        };
        const { data } = await get('agents', options);
        return !!data.length;
    }

    async renameDevice(name: string): Promise<boolean> {
        const exists = await this.existsDeviceName(name);
        if (exists) {
            return false;
        }
        const payload = {
            name: name
        };
        await patch(`agents/${this.device.id}/rename`, payload);
        runInAction(() => {
            this.device.name = name;
        });
        return true;
    }

    async deleteDevice(): Promise<void> {
        await destroy(`agents/${this.device.id}`);
    }

    async moveDevice(id: string, organizationId: string, locationId: string, newOrganizationName: string, newLocationName: string): Promise<void> {
        const conditions = getListConditions([id]);
        const where = buildWhereFilter({
            where: conditions
        });
        const filter = { where: where };
        await post('agents/assignTarget', { targetId: locationId, filter });
        runInAction(() => {
            this.device.organizationId = organizationId;
            this.device.organization = {
                id: organizationId,
                name: newOrganizationName
            };
            this.device.locationId = locationId;
            this.device.location = {
                id: locationId,
                name: newLocationName
            };
        });
    }
}
